const _ = require('lodash');
const utils = require('../../utils');
const ImpressService = require('../../services/ImpressService');
const TrackingService = require('../../services/TrackingService');

module.exports = {
    props: [
        'selectedVerticals', 'index', 'customUrl', 'totalVerticals', 'floatingUiUrl', 'showPreviewLogos',
        'presentingRole', 'presentingRole', 'industry', 'user'
    ],
    template: require('./demo-preview.html'),
    created() {
        ImpressService.onEnter("demo-preview", () => {
            this.openInTenfold = this.getEncodedDemoData();
        });
    },
    data: () => {
        return {
            openInTenfold: ''
        }
    },
    computed: {
        selectedServices() {
            return _(this.selectedVerticals)
                .values()
                .flatMap()
                .uniq()
                .filter(x => x)
                .map(_.kebabCase)
                .slice(0, 15)
                .value();
        },
        selectedSize() {
            return this.selectedServices.length;
        }
    },
    methods: {
        getEncodedDemoData() {
            const demo = utils.createDemoData(this);
            const href = 'tenfold-msg-pb://' + btoa(JSON.stringify({
                command: 'demo',
                window: 'main',
                data: demo
            })) + '/';
            return href;
        },
        styleFor(index, total) {
            const angle = (index * Math.PI * 2 + Math.PI) / total;
            const x = Math.sin(angle);
            const y = Math.cos(angle);
            const size = 160;
            const duration = [0, 1, 2];

            return {
                marginLeft: ((300 + x * 250) - size / 2) + 'px',
                marginTop: ((300 + y * 250) - size / 2) + 'px',
                width: size + 'px',
                height: size + 'px',
                animationDuration: duration[index % duration.length] + 's',
            };
        },
        trackOpenInApp() {
            const data = {};
            if (this.user) {
                data.user = _.get(this.user, 'username');
            }
            TrackingService.trackEvent('open-in-app', data);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/js/components/demo-preview/demo-preview.js
// module id = 93
// module chunks = 0